import Component from '@glimmer/component';

export default class FlipNumber extends Component {
  get digits() {
    const result = [];
    let numberString = String(this.args.number);
    const isNegative = numberString.startsWith('-');
    
    // Remove minus sign for processing
    if (isNegative) {
      numberString = numberString.slice(1);
    }
    
    // Process each digit from right to left
    for (let i = numberString.length - 1; i >= 0; i--) {
      // Add digit
      result.unshift({
        value: numberString[i],
        isNumber: true
      });
      
      // Add comma for thousands (but not at the start)
      if (i > 0 && (numberString.length - i) % 3 === 0) {
        result.unshift({
          value: ',',
          isNumber: false
        });
      }
    }
    
    if (isNegative) {
      result.unshift({
        value: '-',
        isNumber: false
      });
    }
    
    return result;
  }
}